/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralOnboardingRepository = (
    options: GeneralRestApiOptions
): Types.GeneralOnboardingRepository => ({
    async createEnterprise(params, requestOptions) {
        return options.request('/onboarding/createEnterprise', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getOnboardingData(params, requestOptions) {
        return options.request('/onboarding/getOnboardingData', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async sendInvitation(params, requestOptions) {
        return options.request('/onboarding/sendInvitation', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
